import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import LoginPage from "@/pages/LoginPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import DashboardPage from "@/pages/DashboardPage";
import DocumentsPage from "@/pages/DocumentsPage";
import PipelinePage from "@/pages/PipelinePage";
import ProspectsPage from "@/pages/ProspectsPage";
import ProspectDetailPage from "@/pages/ProspectDetailPage";
import EmailsPage from "@/pages/EmailsPage";
import SettingsPage from "@/pages/SettingsPage";
import StrategyEditorPage from "@/pages/StrategyEditorPage";
import TrainingPage from "@/pages/TrainingPage";
import KnowledgePage from "@/pages/KnowledgePage";
import ApprovalQueuePage from "@/pages/ApprovalQueuePage";
import ErrorsPage from "@/pages/ErrorsPage";
import AppLayout from "@/components/AppLayout";
import ErrorBoundary from "@/components/ErrorBoundary";
import type { ReactElement } from "react";

function ProtectedRoute({ element }: { element: ReactElement }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="grid place-items-center h-full text-sm text-zinc-500">Loading…</div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return element;
}

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={<ProtectedRoute element={<AppLayout />} />}
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="approvals" element={<ApprovalQueuePage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="documents" element={<DocumentsPage />} />
          <Route path="emails" element={<EmailsPage />} />
          <Route path="errors" element={<ErrorsPage />} />
          <Route path="knowledge" element={<KnowledgePage />} />
          <Route path="pipeline" element={<PipelinePage />} />
          <Route path="prospects" element={<ProspectsPage />} />
          <Route path="prospects/:id" element={<ProspectDetailPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="strategies" element={<StrategyEditorPage />} />
          <Route path="training" element={<TrainingPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </AuthProvider>
    </ErrorBoundary>
  );
}
